import { EMPTY_STRING } from "src/components/constant/constant";

const STRIPE_GUARD_FLAG = "stripeBackGuard";
const STRIPE_PREVIOUS_URL = "preStripeUrl";
const STRIPE_HISTORY_STATE_KEY = "stripeGuardActive";
let stripePopstateRegistered = false;

/**
 * OAuth `state` for the Xero / QuickBooks / MYOB / Stripe redirects. It is the
 * CSRF token for the callback, so it must be unguessable: 32 bytes from the
 * platform CSPRNG (256 bits), hex-encoded. The previous value was a fixed
 * prefix plus six characters of Math.random() (QA finding, 2026-09-22).
 */
export const generateState = () => {
  const bytes = new Uint8Array(32);

  window.crypto.getRandomValues(bytes);

  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
};

export const markStripeCheckoutStart = () => {
  if (typeof window === "undefined") return;

  sessionStorage.setItem(STRIPE_GUARD_FLAG, "pending");
  sessionStorage.setItem(STRIPE_PREVIOUS_URL, window.location.href);
};

export const installStripeHistoryGuard = () => {
  if (typeof window === "undefined") return;
  if (sessionStorage.getItem(STRIPE_GUARD_FLAG) !== "pending") return;

  window.history.replaceState({ [STRIPE_HISTORY_STATE_KEY]: true }, EMPTY_STRING, window.location.href);
  window.history.pushState({ [STRIPE_HISTORY_STATE_KEY]: true }, EMPTY_STRING, window.location.href);
  sessionStorage.setItem(STRIPE_GUARD_FLAG, "locked");
};

export const registerStripeBackNavigationListener = () => {
  if (typeof window === "undefined" || stripePopstateRegistered) return;

  const handlePopstate = () => {
    const guardState = sessionStorage.getItem(STRIPE_GUARD_FLAG);

    if (guardState === "locked") {
      window.history.forward();
      return;
    }

    if (guardState === "armed") {
      const fallback = sessionStorage.getItem(STRIPE_PREVIOUS_URL) || "/";

      sessionStorage.removeItem(STRIPE_GUARD_FLAG);
      sessionStorage.removeItem(STRIPE_PREVIOUS_URL);

      window.location.replace(fallback);
    }
  };

  window.addEventListener("popstate", handlePopstate);
  stripePopstateRegistered = true;
};

export const armStripeHistoryGuard = () => {
  if (sessionStorage.getItem(STRIPE_GUARD_FLAG) === "locked") {
    sessionStorage.setItem(STRIPE_GUARD_FLAG, "armed");
  }
};
